// extracted by mini-css-extract-plugin
export var text = "_r-0";